import { ReactElement, ReactNode, useRef } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import KeyboardReturn from '@mui/icons-material/KeyboardReturn'
import { LoadingButtonProps } from '@mui/lab'
import SaveButton from '../SaveButton'

interface Props extends LoadingButtonProps {
  children: ReactNode
  hotkey?: string
  showHotkeyInfo?: boolean
}

const HotkeySaveButton = ({
  children,
  hotkey = 'enter',
  showHotkeyInfo = true,
  disabled,
  loading,
  ...props
}: Props): ReactElement => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  useHotkeys(
    hotkey,
    () => {
      buttonRef.current?.click()
    },
    {
      enabled: Boolean(hotkey) && !disabled && !loading,
      preventDefault: true,
    },
    [disabled, loading, hotkey],
  )

  return (
    <SaveButton ref={buttonRef} disabled={disabled} loading={loading} {...props}>
      {children}
      {showHotkeyInfo ? (
        <>
          {' ['}
          <KeyboardReturn fontSize="inherit" sx={{ verticalAlign: 'text-bottom' }} />
          {']'}
        </>
      ) : null}
    </SaveButton>
  )
}

export default HotkeySaveButton
